import { render, staticRenderFns } from "./ui-image.vue?vue&type=template&id=5bcf1f2b&"
import script from "./ui-image.vue?vue&type=script&lang=ts&"
export * from "./ui-image.vue?vue&type=script&lang=ts&"
import style0 from "./ui-image.vue?vue&type=style&index=0&id=5bcf1f2b&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports